// @flow

import { buildCommonComponent } from '@zapier/legacy-components';

// !!! IMPORTANT !!!
//
// The SCSS styles used by this component are no longer accessible. In order to
// modify this component you will need to refactor it to use CSS-in-JS

export const Text = buildCommonComponent('text')('', 'span');
export const Paragraph = buildCommonComponent('text')('--paragraph', 'p');

export default Text;
